import { render, staticRenderFns } from "./WorkGlobal.vue?vue&type=template&id=47f992f9"
import script from "./WorkGlobal.vue?vue&type=script&lang=js"
export * from "./WorkGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports